import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/peran-akses',
    name: 'access',
    component: () => lazyLoadView(import('@views/admin/Access.vue')),
    meta: {
      layouts: 'Layout',
      title: 'Peran Akses',
    },
  },
];
